import { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { MagnifyingGlassIcon, PencilIcon, PrinterIcon, TrashIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import { DataTable } from "../../components/datatable";
import axiosClient from "../../axios-client";
import { useStateContext } from "../../contexts/ContextProvider";
import DatePicker from "../../components/Calendar";
import { Input } from "../../components";
import AddCheque from "./AddCheque";
import PrintCheque from "./PrintCheque";
import ChequeSpinner from "../../components/Spinner";
import PrintChequesList from "./PrintChequesList";
import Swal from "sweetalert2";
import UpdateCheque from "./UpdateCheque";


const Cheques2 = () => {


  const sampleData = [
    {
      id: 1,
      name: "John Doe",
      // email: "john@example.com",
      status: "Active",
      date: "2023-01-15",
    },
    {
      id: 2,
      name: "Jane Smith",
      // email: "jane@example.com",
      status: "Inactive",
      date: "2023-02-20",
    },
    {
      id: 3,
      name: "Bob Johnson",
      // email: "bob@example.com",
      status: "Active",
      date: "2023-03-10",
    },
    {
      id: 4,
      name: "Alice Brown",
      // email: "alice@example.com",
      status: "Pending",
      date: "2023-04-05",
    },
    ...Array.from({ length: 16 }, (_, i) => ({
      id: i + 5,
      name: `User ${i + 5}`,
      // email: `user${i + 5}@example.com`,
      status: ["Active", "Inactive", "Pending"][Math.floor(Math.random() * 3)],
      date: `2023-${String(Math.floor(Math.random() * 12) + 1).padStart(
        2,
        "0"
      )}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, "0")}`,
    })),
  ];

  // Define columns
  const columns = [
    {
      header: "Beneficiaire",
      accessor: "nom",
      sortable: true,
    },
    // {
    //   header: "Email",
    //   accessor: "email",
    //   sortable: true,
    // },
    // {
    //   header: "Status",
    //   accessor: "status",
    //   sortable: true,
    //   cell: (value) => (
    //     <span
    //       className={`px-2 py-1 rounded-full text-xs font-medium ${value === "Active"
    //           ? "bg-green-100 text-green-800"
    //           : value === "Inactive"
    //             ? "bg-red-100 text-red-800"
    //             : "bg-yellow-100 text-yellow-800"
    //         }`}
    //     >
    //       {value}
    //     </span>
    //   ),
    // },
    {
      header: "Date",
      accessor: "dateCheque",
      sortable: true,
    },
    {
      header: "Montant",
      accessor: "formated",
      sortable: true,
    },
    {
      header: "Banque",
      accessor: "banque",
      sortable: true,
    },
  ];

  // Define filter options
  const filterOptions = [
    {
      id: "status",
      label: "Status",
      options: ["", "Active", "Inactive", "Pending"],
    },
  ];

  // Define bulk actions
  const bulkActions = [
    {
      label: "Delete Selected",
      onAction: (selectedIds) => {
        alert(`Deleting IDs: ${selectedIds.join(", ")}`);
      },
    },
    {
      label: "Mark Active",
      onAction: (selectedIds) => {
        alert(`Marking IDs as Active: ${selectedIds.join(", ")}`);
      },
    },
  ];

  const [data, setData] = useState(sampleData);
  const notify = () => toast.success("🦄 Toast is working!");

  const navigate = useNavigate();
  const [errors, setErrors] = useState(null);

  const [cheques, setCheques] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setToken, user, ajouterCheque, supprimerCheque, chequesList } = useStateContext();
  const [showAdd, setShowAdd] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [showPrint, setShowPrint] = useState();
  const [showPrintList, setShowPrintList] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [selcetedCheque, setSelectedCheque] = useState(null);
  const [req, setReq] = useState({
    DateDebut: '',
    DateFin: '',
    nom: '',
  });
  const getCheques = () => {
    setErrors([]);
    setLoading(true);
    axiosClient.get('/cheques?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin)
      .then((data) => {
        setCheques(data.data.cheques);
        setLoading(false);

      }).catch(err => {
        setLoading(false);
        const response = err.response;
        if (response.status === 401) {
          setToken(null);
        }
        else {
          if (response.status === 422) {
            setErrors(response.data.errors);
            setLoading(false);
            toast.error('Une erreur est survenue!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }

        }
      })
  }

  const closeAdd = () => {
    setShowAdd(false);
    getCheques();
  }

  const closeEdit = () => {
    setShowEdit(false);
    getCheques();
  }



  const closeShowPrint = () => {
    setShowPrint(false);
    setSelectedCheque(null);
  }
  const closeShowPrintList = () => {
    setShowPrintList(false);
    //setSelectedCheque(null);
  }

  const supprimer = (cheque) => {
    Swal.fire({
      title: "Confirmation",
      text: "Êtes-vous sûr de supprimer cet élément ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2196F3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui!",
      cancelButtonText: "Non!"
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient.delete('/cheque/' + cheque.id)
          .then(response => {
            toast.success('Opération effectuée avec succès!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            getCheques();
          }).catch(err => {
            const response = err.response;
            if (err.response.status === 401) {
              setToken(null);
            } else {
              if (response.status === 401) {
                setToken(null);
              }
              else {
                if (response.status === 403) {
                  navigate('/403');
                } else {
                  if (response.status === 404) {
                    navigate('/404');
                  }
                  else {
                    navigate('/500');
                  }
                }
              }
            }

          })
      }
    });
  }
  useEffect(() => {
    getCheques();
  }, []);

  const actionButtons = (item) => (
    <>
      <button
        className="p-1.5 hover:bg-zinc-100 rounded-md transition-all duration-200"
        onClick={() => {
          setSelectedCheque(item);
          setShowPrint(true);
        }}
      >

        <PrinterIcon className="h-5 w-5 text-zinc-700" />
      </button>
      <button
        className="p-1.5 hover:bg-zinc-100 rounded-md transition-all duration-200"
        onClick={() => {
          setSelectedCheque(item);
          setShowEdit(true);
        }}
      >

        <PencilIcon className="h-5 w-5 text-zinc-700" />
      </button>
      <button
        className="p-1.5 hover:bg-zinc-100 rounded-md transition-all duration-200"
        onClick={() => {
          supprimer(item);
        }}
      >
        <TrashIcon className="h-5 w-5 text-zinc-700" />
      </button>
    </>
  );

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-zinc-900 mb-6">Cheques</h1>
      {loading ?
        <div className="flex w-full justify-center">
          <ChequeSpinner />
        </div>
        :
        <DataTable
          data={cheques}
          columns={columns}
          addButton={{
            label: "Ajouter",
            onClick: () => {
              setShowAdd(true);
            },
          }}
          searchable={true}
          // filterOptions={filterOptions}
          actionButtons={actionButtons}
          dateFilter={{ accessor: "date" }}
          pagination={true}
          selectable={true}
          bulkActions={bulkActions}
          itemsPerPageOptions={[10, 20, 25]}
          dateSearch={
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 bg-zinc-50 p-3 rounded-lg">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
                <input className="flex items-center border border-zinc-200 rounded-lg px-3 py-2.5 hover:border-zinc-300 transition-colors cursor-text" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} />
                <span className="text-zinc-400 text-sm hidden sm:inline">au</span>
                <input className="flex items-center border border-zinc-200 rounded-lg px-3 py-2.5 hover:border-zinc-300 transition-colors cursor-text" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} />
              </div>
              <div className="flex gap-3 w-full sm:w-auto">
                <button
                  onClick={getCheques}
                  className="flex items-center px-2 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-800 text-sm font-medium transition-all duration-200 w-full sm:w-auto"
                >
                  <MagnifyingGlassIcon className="h-4 w-4" />
                  Chercher
                </button>
                <button
                  onClick={() => {
                    setShowPrintList(true);
                  }
                  }
                  className="flex items-center gap-2 px-4 py-2 bg-zinc-600 text-white rounded-lg hover:bg-zinc-800 text-sm font-medium transition-all duration-200 whitespace-nowrap"
                >
                  <PrinterIcon className="h-4 w-4" />
                  Imprimer
                </button>
              </div>

            </div>
          }
        />

      }

      {
        showAdd ? <AddCheque onClose={closeAdd} /> : <></>
      }
      {
        showEdit ? <UpdateCheque selectedCheque={selcetedCheque} onClose={closeEdit} /> : <></>
      }
      {
        showPrint ? <PrintCheque onClose={closeShowPrint} cheque={selcetedCheque} /> : <></>
      }
      {
        showPrintList ? <PrintChequesList cheques={chequesList} onClose={closeShowPrintList} /> : <></>
      }
    </div>
  );
};

export default Cheques2